export enum NotificationScenario {
    /** ask the user to approve the commitment */
    PUBLISH = 1,

    CLOSE,

    /** a reject sign off occurred for the commitment (used for the send-notification flow) */
    DISPUTE,

    GOAL_ACCEPT,
    GOAL_CLOSE,

    /** an accept sign off occurred for the commitment (used for the send-notification flow) */
    APPROVE,

    /** a commitment was deleted */
    DELETE,

    /** a side-by-side accept sign off occurred for the commitment */
    SIGN_OFF,

    SHARE,

    SHARE_GOAL,

    COMMITMENT_CLOSE_DID_SIGN_OFF,

    COMMITMENT_CLOSE_DID_APPROVE,

    COMMITMENT_UPDATE_DID_SIGN_OFF,

    COMMITMENT_DISPUTE,

    COMMITMENT_APPROVE,

    NEW_COMMITMENT_SEND_APPROVAL,

    UPDATE_COMMITMENT_DISPUTE,
}
